import { Grid, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { useAppSelector } from "../../app/store/configureStore";
import React, { } from "react";
import AppInformationText from "../../app/components/AppInformationText";
import { SummaryDto } from "../../app/models/pcs/summaryDto";
import cpdCategoriesFormModel from "./cpdCategoriesFormModel";

const useStyles = makeStyles(() => ({
    root: {
        "& .MuiPaper-root": {
            width: "unset",
            marginLeft: "0"
        }
    },
    alignCenter: {
        textAlign: 'center'
    },
    gridItem: {
        textAlign: 'center',
        paddingTop: '16px'
    }
}));

interface Props {
    sixYearSummaryData: SummaryDto[][] | null;
    isYearPartialyCompleted: boolean;
    totalOfSummary: number[];
}

export default function SummaryTable({ sixYearSummaryData, isYearPartialyCompleted, totalOfSummary }: Props) {
    const {
        formField: {
            AccreditedCeActivity,
            ProfessionalDevelopmentPlan,
            PracticeReview,
            WorkbasedLearning,
            Total,
            OnTarget
        }
    } = cpdCategoriesFormModel;

    const { summaryTitles } = useAppSelector(state => state.pcs);

    const classes = useStyles();

    const GetSummaryColorCode = (colorName: string) => {
        switch (colorName.toUpperCase()) {
            case "RED":
                return '#d64b5f';
            case "AMBER":
                return "#e46c0a";
            case "GREEN":
                return "#00af66";
            case "WHITE":
                return "#FFFFFF";
            default:
                return "#FFFFFF";
        }
    }

    return <Box sx={{ flexGrow: 1, padding: 2 }} component={Paper} className={classes.root}>

        <Grid container>
            <Grid item display={{ xs: 'block' }} xs={4} sm={1} className={classes.alignCenter}>
                <b>{summaryTitles === null ? '' : summaryTitles[0]}</b>
            </Grid>
            <Grid item display={{ xs: 'none', sm: 'block' }} sm={1} className={classes.alignCenter}>
                <b>{summaryTitles === null ? '' : summaryTitles[1]}</b>
            </Grid>
            <Grid item display={{ xs: 'none', sm: 'block' }} sm={1.5} className={classes.alignCenter}>
                <b>{summaryTitles === null ? '' : summaryTitles[3]}</b>
                <br />
                <AppInformationText information_text={AccreditedCeActivity.informationText} placement="bottom" />
            </Grid>
            <Grid item display={{ xs: 'none', sm: 'block' }} sm={1.5} className={classes.alignCenter}>
                <b>{summaryTitles === null ? '' : summaryTitles[4]}</b>
                <br />
                <AppInformationText information_text={ProfessionalDevelopmentPlan.informationText} placement="bottom" />
            </Grid>
            <Grid item display={{ xs: 'none', sm: 'block' }} sm={1.5} className={classes.alignCenter}>
                <b>{summaryTitles === null ? '' : summaryTitles[5]}</b>
                <br />
                <AppInformationText information_text={PracticeReview.informationText} placement="bottom" />
            </Grid>
            <Grid item display={{ xs: 'none', sm: 'block' }} sm={1.5} className={classes.alignCenter}>
                <b>{summaryTitles === null ? '' : summaryTitles[6]}</b>
                <br />
                <AppInformationText information_text={WorkbasedLearning.informationText} placement="bottom" />
            </Grid>

            <Grid item display={{ xs: 'none', sm: 'block' }} sm={1} className={classes.alignCenter}>
                <b>{Total.label}</b>
                <br />
                <AppInformationText information_text={Total.informationText} placement="bottom" />
            </Grid>

            <Grid item display={{ xs: 'block', sm: 'none' }} xs={2}></Grid>

            <Grid item display={{ xs: 'block' }} xs={6} sm={1.5} className={classes.alignCenter}>
                <b>{summaryTitles === null ? '' : summaryTitles[7]}</b>
                <br />
                <AppInformationText information_text={OnTarget.informationText} placement="bottom" />
            </Grid>

            <Grid item display={{ xs: 'none', sm: 'block' }} sm={1.5} className={classes.alignCenter}>
                <b>{summaryTitles === null ? '' : summaryTitles[8]}</b>
            </Grid>

            {sixYearSummaryData?.map((item: SummaryDto[], index: number) => (
                <React.Fragment key={index}>

                    <Grid item xs={4} sm={1}>
                        <Grid display={{ xs: 'block' }} className={classes.gridItem}>
                            {item[0].text}
                            {item[2].text.toLowerCase() === "true" ? "*" : ""}
                        </Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={1}>
                        <Grid className={classes.gridItem}>{item[1].text}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={1.5} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[3].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{item[3].text.split('(')[0]}</b>({item[3].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={1.5} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[4].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{item[4].text.split('(')[0]}</b>({item[4].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={1.5} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[5].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{item[5].text.split('(')[0]}</b>({item[5].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={1.5} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[6].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}><b>{item[6].text.split('(')[0]}</b>({item[6].text.split('(')[1]}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={1} sx={{ padding: 1 }}>
                        <Grid sx={{ textAlign: 'center', padding: 1 }}>
                            <b>{totalOfSummary[index]}</b>
                        </Grid>
                    </Grid>

                    <Grid item display={{ xs: 'block', sm: 'none' }} xs={2}></Grid>

                    <Grid item display={{ xs: 'block' }} xs={6} sm={1.5} sx={{ padding: 1 }}>
                        <Grid sx={{
                            backgroundColor: GetSummaryColorCode(item[7].status.toUpperCase()),
                            textAlign: 'center', padding: 1
                        }}>{item[7].text}</Grid>
                    </Grid>

                    <Grid item display={{ xs: 'none', sm: 'block' }} sm={1.5}>
                        <Grid className={classes.gridItem}>{item[8].text}</Grid>
                    </Grid>
                </React.Fragment>
            ))}

            {sixYearSummaryData?.length === 0 &&
                <Grid item xs={12} sx={{ textAlign: 'center', padding: 5 }}>No records found.</Grid>
            }

            {isYearPartialyCompleted === true &&
                <Grid item xs={12} sx={{ padding: 2 }}>*Partial Year Completed.</Grid>
            }

            <Grid item display={{ xs: 'none', sm: 'block' }} xs={12} sx={{ padding: 2 }}>
                Note: CPD Category requirements are displayed in brackets.
            </Grid>
        </Grid>
    </Box>
}